import React from 'react';
import PropTypes from 'prop-types';

import AttributeRow from './attribute_row';

import { Row, Col, Card } from 'react-bootstrap-5';
import { reorderableList } from 'helpers/react_dnd/reorderable_list';

export class CompReportAttributeSelector extends React.Component {
  static propTypes = {
    attributeOptions: PropTypes.array.isRequired,
    selectedAttributes: PropTypes.array.isRequired,
    onAttributeRemove: PropTypes.func.isRequired,
    onAttributesClear: PropTypes.func.isRequired,
    onAttributeSelect: PropTypes.func.isRequired,
    onReorder: PropTypes.func.isRequired
  };

  constructor(props) {
    super(props);
    this.state = { value: '' };
  }

  selectableAttributes = () => {
    const { attributeOptions, selectedAttributes } = this.props;

    const attributes = attributeOptions.filter(
      a => !selectedAttributes.includes(a['key'])
    );
    const filteredAttributes = this.state.value
      ? attributes.filter((a) => {
        return a['label']
          .toLowerCase()
          .includes(this.state.value.toLowerCase());
      })
      : attributes;
    // display in alphabetical order
    filteredAttributes.sort((a, b) => {
      return a['label'] < b['label'] ? -1 : a['label'] > b['label'] ? 1 : 0;
    });

    return filteredAttributes;
  };

  selectedAttributes = () => {
    const { attributeOptions, selectedAttributes } = this.props;

    return selectedAttributes.map((selectedAttribute) => {
      return attributeOptions.find(a => a.key === selectedAttribute);
    });
  };

  onSearch = (e) => {
    this.setState({
      value: e.target.value
    });
  };

  renderAttributeRow = (option) => {
    const onClick = () => {
      this.setState({ value: '' });
      this.props.onAttributeSelect(option);
    };
    return (
      <div
        className="p-3 clickable list-group-item border-bottom selectable"
        key={option.key}
        name="attributeRow"
        onClick={onClick}
      >
        {option['label']}
      </div>
    );
  };

  renderSelectedAttributeRow = (option, index) => {
    const { onAttributeRemove, onReorder } = this.props;

    return (
      <AttributeRow
        index={index}
        key={option.key}
        option={option}
        onRemoveAttribute={onAttributeRemove}
        onReorder={onReorder}
      />
    );
  };

  renderAvailableFields() {
    return (
      <Card>
        <Card.Header className="bg-light">Available Fields</Card.Header>
        <Card.Body className="px-0 d-flex flex-column" style={{ height: '400px' }}>
          <div className="px-4 flex-shrink-0">
            <input
              aria-label="search field options by substring"
              className="form-control"
              placeholder="Search Fields"
              type="text"
              value={this.state.value}
              onChange={this.onSearch}
            />
          </div>
          <div className="list-group-flush overflow-y-auto flex-grow-1">
            {this.selectableAttributes().map(this.renderAttributeRow)}
          </div>
        </Card.Body>
      </Card>
    );
  }

  renderSelectedFields() {
    return (
      <Card>
        <Card.Header className="bg-light">
          Selected Fields
          <span
            className="float-end clickable"
            name="clearAttributesLink"
            onClick={this.props.onAttributesClear}
          >
            Clear All
          </span>
        </Card.Header>
        <Card.Body className="px-0 d-flex flex-column" style={{ height: '400px' }}>
          <div className="list-group-flush overflow-y-auto flex-grow-1">
            {this.selectedAttributes().map(this.renderSelectedAttributeRow)}
          </div>
        </Card.Body>
      </Card>
    );
  }

  render() {
    return (
      <Row>
        <Col xs={6}>{this.renderAvailableFields()}</Col>
        <Col xs={6}>{this.renderSelectedFields()}</Col>
      </Row>
    );
  }
}

export default reorderableList(CompReportAttributeSelector);
